/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidatorSignStatsInfo,
    ValidatorSignStatsInfoFromJSON,
    ValidatorSignStatsInfoFromJSONTyped,
    ValidatorSignStatsInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ValidatorSignStatsResponse
 */
export interface ValidatorSignStatsResponse {
    /**
     * 
     * @type {Array<ValidatorSignStatsInfo>}
     * @memberof ValidatorSignStatsResponse
     */
    stats: Array<ValidatorSignStatsInfo>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ValidatorSignStatsResponse
     */
    time: Array<number>;
}

export function ValidatorSignStatsResponseFromJSON(json: any): ValidatorSignStatsResponse {
    return ValidatorSignStatsResponseFromJSONTyped(json, false);
}

export function ValidatorSignStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorSignStatsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stats': ((json['stats'] as Array<any>).map(ValidatorSignStatsInfoFromJSON)),
        'time': json['time'],
    };
}

export function ValidatorSignStatsResponseToJSON(value?: ValidatorSignStatsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stats': ((value.stats as Array<any>).map(ValidatorSignStatsInfoToJSON)),
        'time': value.time,
    };
}


